import { getLogger, tracker } from 'app-components/utils/core';
import store from 'app-components/utils/redux-store';

import * as importActions from 'data/import/importActions';

import importAccounts from './importAccounts';
import importBalances from './importBalances';
import importCategories from './importCategories';
import importLogins from './importLogins';
import importReset from './importReset';
import importTags from './importTags';
import importTransactions from './importTransactions';
import { getMintImportSharedState, mergeMintImportSharedState } from './mintImportSharedState';
// import importHoldings from './importHoldings';

const logger = getLogger('importAsync');

const importAsync = async (fileJS, reset) => {
  try {
    tracker.track(tracker.events.csvImport, { type: 'MintExtension', status: 'start' });
    tracker.timeEvent(tracker.events.csvImport);

    mergeMintImportSharedState({
      error: null,
      key: null,
      progress: null,
      ACCOUNTS: null,
      BALANCES: null,
      CATEGORIES: null,
      LOGINS: null,
      TAGS: null,
      TRANSACTIONS: null,
    });

    if (reset) {
      await importReset();
    }
    const simplifiTagsByMintId = await importTags(fileJS);
    if (!simplifiTagsByMintId) {
      throw new Error('tags import failed');
    }

    const simplifiCOAsByMintId = await importCategories(fileJS);
    if (!simplifiCOAsByMintId) {
      throw new Error('categories import failed');
    }

    const simplifiLoginsByMintId = await importLogins(fileJS);
    if (!simplifiLoginsByMintId) {
      throw new Error('logins import failed');
    }

    const simplifiAccountsByMintId = await importAccounts(fileJS, simplifiLoginsByMintId);
    if (!simplifiAccountsByMintId) {
      throw new Error('accounts import failed');
    }

    const transactionsImportSucceed = await importTransactions(
      fileJS,
      simplifiAccountsByMintId,
      simplifiCOAsByMintId,
      simplifiTagsByMintId,
    );
    if (!transactionsImportSucceed) {
      throw new Error('transactions import failed');
    }

    const balancesImportSucceed = await importBalances(fileJS, simplifiAccountsByMintId);
    if (!balancesImportSucceed) {
      throw new Error('balances import failed');
    }

    // await importHoldings(fileJS, simplifiAccountsByMintId);

    const mintImportSharedState = getMintImportSharedState();
    if (transactionsImportSucceed) {
      await new Promise((resolve, reject) => {
        store.dispatch(importActions.pfmImportMintPromoExtend(undefined, { resolve, reject }));
      });
    }

    mergeMintImportSharedState({ key: 'COMPLETE', progress: 100 });
    logger.info('import complete: ', mintImportSharedState);
    tracker.track(tracker.events.csvImport, { type: 'MintExtension', status: 'success' });

    return mintImportSharedState;
  } catch (e) {
    assert(false, e);
    const mintImportSharedState = getMintImportSharedState();
    mergeMintImportSharedState({ error: mintImportSharedState.key });

    tracker.track(tracker.events.csvImport, {
      type: 'MintExtension',
      status: 'error',
      details: mintImportSharedState.error,
    });

    return e;
  }
};

export default importAsync;
